<template>
  <a-card
    :bordered="false"
    title="品牌列表"
  >
    <a-button type="primary" size="small" style="margin-bottom: 20px" @click="editBrand(0)">添加品牌</a-button>
    <tcg-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      bordered
      class="mt-20"
    >
      <span
        slot="action"
        slot-scope="text,record"
      >
        <a-button
          type="link"
          @click="jumpGoodsCategory(record)"
        >查看</a-button>
        <a-button
          type="link"
          @click="editBrand(record)"
        >编辑</a-button>
        <a-button
          type="link"
          @click="delOption(record)"
        >删除</a-button>
      </span>
    </tcg-table>
    <a-modal
      title="编辑品牌信息"
      v-if="brandInfo"
      :visible="brandInfo"
      @ok="preserve()"
      @cancel="brandInfo = false"
    >
      <a-row :gutter="48">
        <a-col :md="24" :sm="24">
          <a-form-item>
            品牌名：<a-input style="width: 200px; margin: 0 10px" v-model="list.brand_name" placeholder="请输入品牌名" /><br/>
            排序：<a-input-number style="width: 200px; margin: 0 23px" :precision="0" :max="30000" v-model="list.sort" placeholder="数越大越靠前" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-modal>
  </a-card>
</template>
<script>
import { getBrandList, brandUpdate, brandCondition, brandDelete } from '@/api/brand'
import { TcgTable } from '@/components'

export default {
  name: 'BrandIndex',
  components: { TcgTable },
  data() {
    return {
      // 品牌列表
      list: {
        brand_id: 0,
        brand_name: '',
        sort: 0
      },
      brandInfo: false,
      columns: [
        {
          title: '品牌名',
          dataIndex: 'brand_name'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          width: '120px'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time'
        },
        {
          title: '编辑',
          align: 'center',
          dataIndex: 'id',
          width: '250px',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      loadData: () => {
        return getBrandList().then((res) => {
          return res
        })
      }
    }
  },
  methods: {
    // 添加选项
    editBrand(item) {
      if (item !== 0) {
        this.list.brand_id = item.brand_id
        this.list.brand_name = item.brand_name
        this.list.sort = item.sort
      } else {
        this.list.brand_id = 0
        this.list.brand_name = ''
        this.list.sort = 0
      }
      this.brandInfo = true
    },
    // 删除选项
    delOption(item) {
      this.$confirm({
        title: '确定要删除?',
        onOk: () => {
          // 获取删除条件
          brandCondition(item)
            .then((res) => {
              if (res.code === 200) {
                if (res.error) {
                  this.$message.warning(res.message)
                } else {
                  // 可以删除, 再次确认
                  this.delete(item)
                }
              }
            })
        }
      })
    },
    delete(item) {
      this.$confirm({
        title: '确定要删除该品牌吗？',
        onOk: () => {
          brandDelete(item)
            .then((dd) => {
              if (dd.code === 200) {
                this.$message.success(dd.message)
                this.$refs.table.refresh(true)
              }
            })
            .catch(() => {
              this.$message.error('操作失败！')
            })
        }
      })
    },
    // 保存设置
    preserve() {
      brandUpdate(this.list)
        .then((res) => {
          if (res.code === 200) {
            this.brandInfo = false
            this.$message.success(res.message)
            this.$refs.table.refresh(true)
          }
        })
        .catch((e) => {
          this.$message.error('操作失败！')
        })
    },
    // 查看该品牌下的分类
    jumpGoodsCategory(item) {
      var brand_id = item.brand_id
      this.$router.push({ name: 'goodsTypeList', query: { brand_id } })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
